import type { Components, Theme } from "@mui/material";

export const MuiButtonGroup: Components<Theme>["MuiButtonGroup"] = {
  defaultProps: {
    disableElevation: true,
  },
};
